import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {H4, H5, Regular, ProgressTabs} from '@modifi/ui'

import {Wrapper, Content, EmptyState} from './styles'
import routeConfig from '../../../../routes/constants'
import InvoiceList from '../invoice-list'
import {InvoicesEmptyGraphic} from '../../../../assets/graphics'
import {invoiceListShape} from '../../shapes'

class Billing extends Component {
  static propTypes = {
    productTypes: PropTypes.arrayOf(PropTypes.string),
    activeTab: PropTypes.string,
    switchTab: PropTypes.func.isRequired,
    isActiveTabLoading: PropTypes.bool.isRequired,
    fetchInvoices: PropTypes.func.isRequired,
    invoiceList: invoiceListShape.isRequired,
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {
    productTypes: [],
    activeTab: null,
  }

  componentDidMount() {
    const {activeTab, fetchInvoices} = this.props

    activeTab && fetchInvoices(activeTab)
    this.redirectToDefault()
  }

  componentDidUpdate(prevProps) {
    const {productTypes} = this.props

    if (productTypes !== prevProps.productTypes) {
      this.redirectToDefault()
    }
  }

  handleTabClick = (e, newTab) => {
    const {switchTab, activeTab} = this.props
    const {URL} = routeConfig[newTab]
    if (activeTab !== newTab) {
      switchTab(URL)
    }
  }

  redirectToDefault() {
    const {activeTab, productTypes, switchTab} = this.props

    if (activeTab === null) {
      const {URL} =
        productTypes.length > 0 ? routeConfig[productTypes[0]] : routeConfig.SELLER_FINANCING
      switchTab(URL)
    }
  }

  render() {
    const {productTypes, activeTab, isActiveTabLoading, invoiceList, t} = this.props
    const isTabVisible = productTypes.length > 1

    if (!activeTab) return null

    return (
      <Wrapper>
        <H4 my={30}>{t('invoices-page.headline')}</H4>

        {isTabVisible && (
          <ProgressTabs
            options={productTypes.map(productType => ({
              ...routeConfig[productType],
              label: t(`invoices-page.tab.${productType}.text`),
            }))}
            activeTab={activeTab}
            loading={isActiveTabLoading}
            onTabClick={this.handleTabClick}
          />
        )}

        <Content show={!isActiveTabLoading && invoiceList.length === 0}>
          <EmptyState isTabVisible={isTabVisible}>
            <InvoicesEmptyGraphic width={220} height={220} />
            <H5>{t('invoices-page.no-result.text')}</H5>
            <Regular>{t(`invoices-page.${activeTab}.description`)}</Regular>
          </EmptyState>
        </Content>

        <Content show={!isActiveTabLoading && invoiceList.length > 0}>
          <InvoiceList invoiceList={invoiceList} />
        </Content>
      </Wrapper>
    )
  }
}

export default Billing
